var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6633 9.35453C19.3375 8.91703 18.8358 8.66537 18.2867 8.66537H17.5008V5.7487C17.5008 3.6812 15.8183 1.9987 13.7508 1.9987H8.70417C8.51083 1.9987 8.3175 1.95286 8.145 1.86703L5.51583 0.552031C5.22833 0.408698 4.90667 0.332031 4.58417 0.332031H2.9175C1.30833 0.332031 0 1.64036 0 3.2487V14.9154C0 16.9829 1.6825 18.6654 3.75 18.6654H15.0483C16.7175 18.6654 18.1608 17.5912 18.6458 15.9745L19.9267 10.8595C20.0833 10.3379 19.9867 9.78953 19.6633 9.35453ZM0.833333 14.9154V3.2487C0.833333 2.10036 1.7675 1.16536 2.91667 1.16536H4.58333C4.77667 1.16536 4.97 1.2112 5.1425 1.29703L7.77167 2.61203C8.05917 2.75536 8.38083 2.83203 8.70333 2.83203H13.75C15.3583 2.83203 16.6667 4.14036 16.6667 5.7487V8.66537H6.7625C5.52083 8.66537 4.41417 9.44703 4.00333 10.627L1.97583 17.2304C1.28083 16.697 0.8325 15.8579 0.8325 14.9162L0.833333 14.9154ZM19.1233 10.6387L17.8425 15.7537C17.4692 16.997 16.3458 17.832 15.0475 17.832H3.75C3.3875 17.832 3.04083 17.7654 2.72167 17.6445L4.79583 10.8854C5.085 10.0554 5.875 9.49786 6.7625 9.49786H18.2858C18.5692 9.49786 18.8267 9.6262 18.995 9.8512C19.16 10.0729 19.2092 10.3537 19.1233 10.6379V10.6387Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResource);
export default __webpack_public_path__ + "static/media/resource.6f3d0ad74e92aedd8e3848df2ffb21a3.svg";
export { ForwardRef as ReactComponent };